import React, { useEffect } from "react";

import currentUserInfo from "../selectors/currentUserInfo";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

// import NewHome from "../containers/home/NewHome";
import NewClassicStoryGamesHome from "../containers/home/NewClassicStoryGamesHome";

const ReferralLandingPage = (props) => {
  const currentUser = useSelector(currentUserInfo);
  const history = useHistory();

  useEffect(() => {
    if (currentUser) {
      console.log(currentUser);
      history.push("/plans");
    }

    sessionStorage.setItem("previousRoute", "/plans");

    // eslint-disable-next-line
  }, []);

  return (
    <>
      {/* <NewHome {...props} referralPage={true} /> */}
      <NewClassicStoryGamesHome {...props} referralPage={true} />
    </>
  );
};

export default ReferralLandingPage;
